"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLocalStorage = exports.removeValueFromLocalStorage = exports.setValueToLocalStorage = exports.getValueFromLocalStorage = void 0;
/**
 * Get value from storage for given key.
 *
 * @param  {string}  key
 * @return {string}
 */
function getValueFromLocalStorage(key) {
    try {
        if (key) {
            var value = localStorage.getItem(key);
            return JSON.parse(value);
        }
    }
    catch (e) {
        return null;
    }
}
exports.getValueFromLocalStorage = getValueFromLocalStorage;
/**
 * Set key value pair in storage.
 *
 * @param {string} key
 * @param {any} value
 */
function setValueToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
exports.setValueToLocalStorage = setValueToLocalStorage;
/**
 * Remove key value pair in storage.
 *
 * @param {string} key
 */
function removeValueFromLocalStorage(key) {
    localStorage.removeItem(key);
}
exports.removeValueFromLocalStorage = removeValueFromLocalStorage;
/**
 * Clear storage.
 *
 * @return {string}
 */
function clearLocalStorage() {
    return localStorage.clear();
}
exports.clearLocalStorage = clearLocalStorage;
//# sourceMappingURL=storage.js.map